import {TranslatableField} from '../../../types';
import {FieldStatus} from '../FieldStatus';

import Styles from './FieldStatusQuickView.scss';

export interface Props {
  status?: TranslatableField['status'];
}

export function FieldStatusQuickView({status}: Props) {
  if (!status) return null;

  let statusMarkup = null;

  if (status?.machineTranslated) {
    statusMarkup = <FieldStatus status="AutoTranslated" />;
  }

  return statusMarkup ? (
    <div className={Styles.FieldStatusQuickView}>{statusMarkup}</div>
  ) : null;
}
